import { getFileDownload, postForm } from '../../util/fetch';

export const fileUpload = (formData: FormData) => {
  return postForm<{ fileUid: string; fileName: string }>('/api/file', formData);
};

// fileUid 끝에 확장자가 붙어 있다(예: xxx.pdf). 다운로드 파일명에 같은 확장자를 쓴다
export const getFileExtension = (fileUid: string) => (fileUid.includes('.') ? `.${fileUid.split('.').pop()}` : '');

export const viewFileByUid = (fileUid: string, fileName?: string) => {
  return getFileDownload(`/api/file/view/${fileUid}`, fileName);
};
